import { IconLoader, SidepanelDefaultRow } from '@ui/src';
import { CardTransaction as CardTransactionState } from '../../../hoc/common/types';

import cn from './suspicious-transaction.module.css';

interface CardTransactionProps {
  transaction: CardTransactionState;
  isLoading: boolean;
}

const CardTransaction = ({
  transaction,
  isLoading,
}: CardTransactionProps): React.JSX.Element => {
  let content: React.JSX.Element;

  if (isLoading) {
    content = (
      <div className={cn.transactionLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        <div className={cn.accontCardTransactionBlock}>
          <SidepanelDefaultRow title="Description:">
            {transaction.description}
          </SidepanelDefaultRow>
          <SidepanelDefaultRow title="Currency:">
            {transaction.currency.toUpperCase()}
          </SidepanelDefaultRow>
          <SidepanelDefaultRow title="Amount BC:">
            {transaction.amountBc}
          </SidepanelDefaultRow>
          <SidepanelDefaultRow title="Amount:">
            {transaction.amount}
          </SidepanelDefaultRow>
        </div>
        <div className={cn.accontCardTransactionBlock}>
          <SidepanelDefaultRow title="Merchant name:">
            {transaction.merchantName}
          </SidepanelDefaultRow>
          <SidepanelDefaultRow title="Terminal ID:">
            {transaction.terminalId}
          </SidepanelDefaultRow>
          <SidepanelDefaultRow title="Amount BC:">
            {transaction.amountBc}
          </SidepanelDefaultRow>
          <SidepanelDefaultRow title="Amount:">
            {transaction.amount}
          </SidepanelDefaultRow>
        </div>
      </>
    );
  }

  return content;
};

export default CardTransaction;
